import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ServiceSubject} from '../../../../Models/ServiceSubject';
import {LanguageService} from '../../../../../translation/Services/language.service';
import {SolutionService} from '../../../../Services/solution.service';
import {TranslateService} from '@ngx-translate/core';
import {ServiceSubjectService} from '../../../../Services/service-subject.service';
import {Solution} from '../../../../Models/Solution';

@Component({
  selector: 'app-service-subject-solution-overview',
  templateUrl: './service-subject-solution-overview.component.html',
  styleUrls: ['./service-subject-solution-overview.component.scss']
})
export class ServiceSubjectSolutionOverviewComponent implements OnInit {
  @Input() serviceSubject: ServiceSubject;
  public isEdit = false;
  public solution = new Solution();
  public solutionName: string;
  public solutionId: number;
  public languages = [];
  public languageMap = {};
  @ViewChild('deleteSolutionModal', {static: false}) deleteSolutionModal;
  private serviceRequestItemTranslationFields = ['name', 'description'];
  public statuses = [
    {label: this.translateService.instant('global.active'), value: true},
    {label: this.translateService.instant('global.inactive'), value: false}
  ];

  constructor(
    private languageService: LanguageService,
    private solutionService: SolutionService,
    private translateService: TranslateService,
    private serviceSubjectService: ServiceSubjectService
  ) {
  }

  ngOnInit() {
    this.languageService.list().subscribe(langResp => {
      this.languages = langResp.languages;
      this.languages.forEach(lang => {
        this.languageMap[lang.locale] = lang.locale;
      });
    });
  }

  positionChange(position: number, id: number) {
    this.solutionService.setPosition({position}, id).subscribe(res => {
      if (res) {
        this.updateServiceSubject();
      }
    });
  }

  openSoftDeleteConfirm(id: number, name: string) {
    this.solutionId = id;
    this.solutionName = name;
    this.deleteSolutionModal.show();
  }

  getServiceSubjectSolutions(): Solution[] {
    const items = [];
    this.serviceSubject.solutions.forEach(item => {
        items.push(item);
    });
    items.sort((a, b) => a.position > b.position ? 1 : -1);
    return items;
  }

  softDeleteSolution() {
    this.solutionService.deleteSolution(this.solutionId).subscribe(res => {
      this.deleteSolutionModal.hide();
      this.updateServiceSubject();
    });
  }

  updateServiceSubject() {
    this.serviceSubjectService.getServiceSubject(this.serviceSubject.id).subscribe(serviceSubject => {
      this.serviceSubject = serviceSubject;
    });
  }

  getFilteredItems(solutions: Solution[]) {
    const items = [];
    solutions.forEach(item => {
      items.push(item);
    });
    items.sort((a, b) => a.position > b.position ? 1 : -1);
    return items;
  }
}
